import { IconProps } from "./";
import Icon from "./assets/help_info_16.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon16HelpInfo(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
